import { useState } from 'react';

interface UseDragAndDropProps {
  onDrop: (itemType: string) => void;
  acceptedType: string;
}

export function useDragAndDrop({ onDrop, acceptedType }: UseDragAndDropProps) {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (_e: React.DragEvent) => {
    setIsDragOver(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();

    const controlType = e.dataTransfer.getData('text/plain');
    if (controlType === acceptedType) {
      e.stopPropagation();
      onDrop(controlType);
    }

    setIsDragOver(false);
  };

  return {
    isDragOver,
    handleDragOver,
    handleDragLeave,
    handleDrop,
  };
}
